import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";
import {pollsView_template} from "../components/templates/pollsView_template";

declare var ko: any;
declare var page: any;

export class polls_view extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected pollsView: pollsView_template;

    protected getModuleName(){

        return "polls_view";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.pollsView = new pollsView_template("editForm", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("View Poll");

        return [this.pollsView.build()];
    }

    public fillPage() : void{

        this.getData();
    }

    protected getMemoryViewModel(){
        let templateViewModel = this.pollsView.getTemplateViewModel();

        //delete templateViewModel.Job;

        return templateViewModel;
    }

    protected getData(){

        let id: number;

        if ((id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.pollsView.getTemplateViewModel().id(id);
        }

        this.loadingIn(this.pollsView.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/polls/get/' + id;
        let usrReq_params: Array<Array<string>> = [];
        //usrReq_params.push(["data", ko.toJSON(this.pollsEdit.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed.data);
                obj.loadingOut(obj.pollsView.builtTemplate);
            });
        }
    }

    protected updateList(data){

        this.pollsView.setId(data.id);
        this.pollsView.setName(data.name);
        this.pollsView.setDescription(data.description);
        this.pollsView.setType(data.type);
        this.pollsView.setDateClosed(data.dateClosed);
        let choices = this.formatChoices(data.choices ? data.choices : []);
        this.pollsView.setChoices(choices);
        if (data.discussionArticle) {
            this.pollsView.setDiscussionArticle(data.discussionArticle.title);
        }
    }

    protected formatChoices(choices){
        let totalVotes = 0;
        for(let choice of choices){
            totalVotes += choice.votes;
        }
        for(let choice of choices){
            choice.percentage = Math.round((choice.votes/totalVotes)*100);
        }
        this.pollsView.setTotalVotes(totalVotes);
        return choices;
    }

    protected edit(id) {

        page.redirect('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/polls/edit/' + id);
    }


    protected cancel(id) {
        //release lock
        this.releaseLock(id);
        page.redirect('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/polls/');
    }

    protected releaseLock(id) {
        // request a lock release
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/polls/release/' + id;
        let usrReq_params: Array<Array<string>> = [];
        //usrReq_params.push(["data", this.pollsEdit.getTemplateViewModel().id()]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.execute();
    }

}


// WEBPACK FOOTER //
// ./js/modules/polls_view.ts